import { useSWRList } from '@hooks/use-swr-list';
import { MX_PLAN_TYPES_BASE_URL } from './constants';
import { getPetDetailParams } from './functions';

// in order to retrieve individual pricing for a cadence, we need
// to be able to piece together a list of combinations per cadence
export const useMxPlanCombosList = ({
  subscriptionId,
  mealPlanId,
  petDetails = undefined,
  cadences,
}) => {
  const allParamsAvailable =
    subscriptionId && mealPlanId && Boolean(cadences.length);

  const params = petDetails ? getPetDetailParams(petDetails) : '';

  const { data, error } = useSWRList(
    allParamsAvailable
      ? cadences.map(
          cadence =>
            `${MX_PLAN_TYPES_BASE_URL}${subscriptionId}/plans/${mealPlanId}/?cadence=${cadence}${
              petDetails && cadence
                ? `&${params.toString()}`
                : petDetails
                ? `?${params.toString()}`
                : ''
            }`,
        )
      : null,
  );

  return {
    isLoading: allParamsAvailable ? !data && !error : false,
    data,
    error,
  };
};
